import { motion, AnimatePresence } from 'framer-motion'
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useWindowDimensions from '../utility/DimensionTracker';
import '../styles/ui/gimmick.scss'
import ReactHowler from 'react-howler';

const Gimmick = ({isPlaying, setMusic}) => {
    
    const [isOpen, setOpen] = useState(false)
    const { height, width } = useWindowDimensions();

    const location = useLocation();
    const [atTop, setAtTop] = useState(true)

    const [gimmick, setGimmick] = useState(false)
    const [chosenGimmick, setChosen] = useState(0)

    const [bug, setBug] = useState(false)

    const setBigBug = () => (
        setBug(true)
    )

    const [gross, setGross] = useState(false)

    const setBleh = () => (
        setGross(true)
    )

    const randomNum = (range) => {
        return Math.floor(Math.random() * range);
    }


    useEffect(()=>{
        location.pathname === '/' ? setAtTop(false) : setAtTop(true)
        
        const firstRandom = randomNum(100)

        console.log(firstRandom)

        if( firstRandom < 15) {

            setGimmick(true)

            let chosen = randomNum(100)

            if(chosen < 30)
            {
                setChosen(0)
            }
            else if (chosen < 60){
                setChosen(1)
            }
            else if (chosen < 80){
                setChosen(2)
            }
            else if (chosen < 100){
                setChosen(3)
            }
        }


    },[location])

    useEffect(()=>{
        setTimeout(()=>{
            setGimmick(false)
        }, 15000)
    }, [])

    useEffect(()=>{
        setTimeout(()=>{
            setGross(false)
        }, 3000)
    }, [gross])

    useEffect(()=>{
        setTimeout(()=>{
            setBug(false)
        }, 3000)
    }, [bug])

    return (
        atTop && gimmick && width >= 900 && <div className="gimmick-container">
            <AnimatePresence>
                {   chosenGimmick===0 && <WalkyBoy/>    }
                {   chosenGimmick===1 && <SpoopyFlamingo/>  }
                {   chosenGimmick===2 && <TrainGoBrr/>  }
                {   chosenGimmick===3 && <BuggyBoy setBigBug={setBigBug}/>    }
                {
                    bug && <BigBug/>
                }
                {
                    gross && <Gross/>
                }
            </AnimatePresence>
        </div>
    )
}

const WalkyBoy = () => {

    const [visible, setVisible] = useState(true)
    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 9000)
    },[])

    return (
        visible && <motion.div className="walky-boy"
            initial={{
                left: 0,
                top: 0
            }}
            animate={{
                left: '100%',
                top: '100%'
            }}
    
            transition={{
                duration: 9,
    
            }}
        >
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick5.mp3`} playing={true} loop={false}/>
        </motion.div>
    )
}

const SpoopyFlamingo = () => {

    const [visible, setVisible] = useState(true)
    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 3000)
    },[])

    return (
        visible &&<motion.div className="spoopy-flamingo">
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick2.mp3`} playing={true} loop={false}/>
        </motion.div>
    )
}

const TrainGoBrr = () => {

    const [visible, setVisible] = useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 5000)
    },[])

    return (
        (
            visible && <motion.div className="train-spoop"
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1
                }}
                transition={{
                    duration: 2
                }}
                exit={{
                    opacity: 0
                }}
            >
                <motion.div className="train"
                    initial={{
                        x: -1000,
                        y: -1000
                    }}
                    animate={{
                        x: 1000,
                        y: 1000
                    }}
                    transition={{
                        duration: 2,
                        delay: 1
            
                    }}
                >
                    <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick3.mp3`} volume={2} playing={true} loop={false}/>
                </motion.div>
            </motion.div>
        )
    )
}

const BuggyBoy = ({setBigBug}) => {
    const [visible, setVisible] = useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 9000)
    },[])

    return (
        visible && <motion.div className="buggy-boy"
            initial={{
                right: '40%',
                top: "100%"

            }}
            animate={{
                right: '60%',
                top: '-20%'
            }}
            exit={{
                opacity: 0
            }}

            transition={{
                duration: 9,
                ease: 'easeOut'
            }}
            onClick={()=>{
                setBigBug()
                setVisible(false)
            }}
        >
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick4.mp3`} playing={true} loop={false}/>
        </motion.div>
    )
}

const BigBug = () => {

    const [visible, setVisible] = useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 2000)
    },[])

    return (
        visible && <motion.div className="bigbug"
            initial={{
                top: "200%"

            }}
            animate={{
                top: '-300%'
            }}

            transition={{
                duration: 2,
                ease: 'easeOut'
            }}
        >   
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick4b.mp3`} volume={3} playing={true} loop={false}/>
        </motion.div>
    )
}

const Shelly = ({setBleh}) => {

    const [visible, setVisible] = useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 3000)
    },[])


    return ( 
        visible && <motion.div className="shelly"
            initial={{
                top: 0,
                left: '0'

            }}

            onClick={()=>{
                setBleh()
                setVisible(false)
            }}
        >
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick6.mp3`} volume={1} playing={true} loop={false}/>
        </motion.div>
    )
}

const Gross = () => {

    const [visible, setVisible] = useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setVisible(false)
        }, 2000)
    },[])

    return (
        visible && <div className="gross">   
            <ReactHowler src={`${process.env.PUBLIC_URL}/sound/se/gimmick1.mp3`} volume={3} playing={true} loop={false}/>
        </div>
    )
}

export default Gimmick;